import { render, staticRenderFns } from "./PlayerRegistrationFormTeamCard.vue?vue&type=template&id=3f237e80&scoped=true&"
import script from "./PlayerRegistrationFormTeamCard.vue?vue&type=script&lang=js&"
export * from "./PlayerRegistrationFormTeamCard.vue?vue&type=script&lang=js&"
import style0 from "./PlayerRegistrationFormTeamCard.vue?vue&type=style&index=0&id=3f237e80&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f237e80",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VProgressCircular,VRow,VSpacer})
